/* eslint-disable no-underscore-dangle */
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

const { LP, $ } = window;

const FacetPanelFooter = ({ panelId, context, showMore }) => {
  const [disabled, setDisabled] = useState();
  const paramStore = context.getStore('ParamStore');
  const panelStore = context.getStore('PanelStore');
  const gradesFacetPosition = panelStore.position('grade_ids', panelId);

  const setStateFromStore = () => {
    setDisabled(
      ['ccss', 'ss_ids'].includes(panelId) && !paramStore.isActive('grade_ids')
    );
  };

  useEffect(() => {
    setStateFromStore();
    paramStore.addChangeListener(setStateFromStore);
    return () => {
      paramStore.removeChangeListener(setStateFromStore);
    };
  }, []);

  if (!(['ccss', 'ss_ids'].includes(panelId) && panelStore._panels?.grade_ids))
    return null;

  const handleClick = () => {
    if (disabled) {
      $('html,body').animate({
        scrollTop: $('.lp-filter-group.parent-grade_ids').offset().top - 125
      });
      setTimeout(() => {
        $('.grades').parent().addClass('lp-filter-highlight');
      }, 800);
      setTimeout(() => {
        $('.grades').parent().removeClass('lp-filter-highlight');
      }, 3200);
      return;
    }

    context.executeAction(LP.module('Searches').SearchActions.togglePanelShowMore, {
      key: panelId
    });
  };

  const content = () => {
    if (disabled) {
      return `Select at least one option from ${panelStore._panels.grade_ids.name} ${gradesFacetPosition} to see specific standards`;
    }

    if (showMore) {
      return 'Hide Specific Standards';
    }

    return 'Expand Specific Standards';
  };

  const icon = () => {
    if (disabled) {
      const arrowIcon = gradesFacetPosition === 'above' ? 'fa-arrow-up' : 'fa-arrow-down';

      return <i className={`lp-icon-arrow fa-solid ${arrowIcon}`} />;
    }

    if (showMore) {
      return <i className="lp-icon-arrow fa-solid fa-caret-up" />;
    }

    return <i className="lp-icon-arrow fa-solid fa-caret-right" />;
  };

  return (
    <div
      className={`lp-filter-required-message text-primary leading-snug bg-gray-50 hover:bg-primary rounded text-center cursor-pointer py-2 px-1 ${
        disabled ? '' : 'active'
      }`}
      onClick={handleClick}
    >
      {content()}
      {icon()}
    </div>
  );
};

FacetPanelFooter.propTypes = {
  panelId: PropTypes.string,
  context: PropTypes.object,
  showMore: PropTypes.bool
};

export default FacetPanelFooter;
